var map = {
	"./Graphics Final.jpg": 46,
	"./Screenshot 1.JPG": 47,
	"./Screenshot 2.JPG": 48,
	"./Screenshot 3.JPG": 49,
	"./Screenshot 4.JPG": 50,
	"./away.jpg": 51,
	"./balizooandroid1.jpg": 52,
	"./balizooandroid2.jpg": 53,
	"./balizooandroid3.jpg": 54,
	"./balizoowebsite1.JPG": 55,
	"./balizoowebsite2.JPG": 56,
	"./balizoowebsite3.JPG": 57,
	"./balizoowebsite4.JPG": 58,
	"./bezier.JPG": 59,
	"./chemistry.jpg": 60,
	"./chemistry1.png": 61,
	"./converter.jpg": 62,
	"./converter1.jpg": 63,
	"./converter2.jpg": 64,
	"./converter3.jpg": 65,
	"./english.jpg": 66,
	"./english1.jpg": 67,
	"./img_slideshow1.jpg": 68,
	"./img_slideshow2.jpg": 69,
	"./img_slideshow2vr.jpg": 70,
	"./img_slideshow3.jpg": 71,
	"./img_slideshow3vr.jpg": 72,
	"./img_slideshow4.jpg": 73,
	"./img_slideshow4vr.jpg": 74,
	"./img_slideshow5.jpg": 75,
	"./img_slideshow5vr.jpg": 76,
	"./img_slideshow6.jpg": 77,
	"./img_slideshow6vr.jpg": 78,
	"./nao.jpg": 79,
	"./partybolaget1.JPG": 80,
	"./partybolaget2.JPG": 81,
	"./partybolaget3.JPG": 82,
	"./pemilu1.JPG": 83,
	"./pemilu2.JPG": 84,
	"./pemilu3.JPG": 85,
	"./pemilu4.JPG": 86,
	"./photo.JPG": 23,
	"./spotify.jpg": 87,
	"./spotify1.png": 88,
	"./storyboarding.JPG": 89,
	"./storyboarding1.JPG": 90,
	"./timelapse.jpg": 91,
	"./visualizing_error1.JPG": 92,
	"./visualizing_error2.JPG": 93,
	"./visualizing_error3.JPG": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;